/**
 * 追加設問データ定義
 * プロフィール生成のための追加質問項目
 */

// 競技役割（複数選択・14項目）
export const roleOptions = [
  '主将（キャプテン）',
  '副将（副キャプテン）',
  '学年リーダー',
  'チームまとめ役',
  'ムードメーカー',
  'サポート役',
  '個人成績型',
  '戦術分析役',
  '練習牽引型',
  '相談役',
  '調整役',
  '技術指導役',
  '新人育成役',
  '役職なし',
];

// 経験イベント（複数選択・19項目）
export const eventOptions = {
  sports: [
    '全国大会出場',
    '地方大会優勝',
    '国際大会出場',
    '長期間のスランプ経験',
    '大きな怪我からの復帰',
    'チーム内コンフリクトの解決',
    '後輩・新人の指導',
    '戦術やプレースタイルの転換',
    '監督・コーチとの信頼構築',
    'トレーニング方法の独自開発',
  ],
  nonSports: [
    'アルバイト・インターン経験',
    'ボランティア活動',
    '学業との両立',
    '留学・海外遠征',
    '資格取得',
    'SNS・メディア発信',
    'イベント企画・運営',
    'ゼミ・研究活動',
    'コミュニティ活動・地域貢献',
  ],
};

// 行動特性の質問と選択肢
export const behaviorQuestions = {
  hardExperience: {
    question: '競技人生で最も苦しかった経験は何ですか？',
    options: [
      '怪我や病気による長期離脱',
      'レギュラー争い・ポジション争い',
      'チーム内の人間関係のトラブル',
      'スランプ・成績の低迷',
      '引退・進路の選択',
      '監督やコーチとの衝突',
    ],
  },
  overcomingMethod: {
    question: 'その困難をどのように乗り越えましたか？',
    options: [
      '自分で考え、地道に努力を続けた',
      'チームメイトや仲間に相談し、協力して乗り越えた',
      '指導者やメンターのアドバイスを受け入れた',
      '環境や方法を大きく変えてチャレンジした',
      '気持ちを切り替え、別の目標を設定した',
      '周囲を巻き込んで、チーム全体で解決した',
    ],
  },
  teamRole: {
    question: 'チームの中であなたはどんな存在でしたか？',
    options: [
      'みんなを引っ張るリーダー',
      '裏方でチームを支える縁の下の力持ち',
      '相談を受けることが多い信頼される存在',
      '雰囲気を明るくするムードメーカー',
      '冷静に分析し、戦略を考える参謀役',
      '新しいことに挑戦し、変化を起こす革新者',
    ],
  },
};

// デュアルキャリア条件の質問と選択肢
export const dualCareerQuestions = {
  practice: {
    question: '練習スケジュールについて',
    options: [
      '毎日練習が必要',
      '週5〜6日は練習したい',
      '週3〜4日の練習で十分',
      '週1〜2日の練習でよい',
    ],
  },
  competition: {
    question: '大会・試合について',
    options: [
      '月に複数回の大会参加が必要',
      '月1回程度の大会参加',
      'シーズン中のみ大会参加',
      '年に数回の大会参加で十分',
    ],
  },
  competitionPriority: {
    question: '競技と仕事の優先度について',
    options: [
      '競技が最優先（仕事は副次的）',
      '競技優先だが、仕事にも真剣に取り組みたい',
      '仕事と競技を同等に両立したい',
      '仕事優先で、余暇に競技を続けたい',
    ],
  },
  workStyle: {
    question: '希望する働き方について',
    options: [
      'フルタイム勤務',
      '時短勤務・フレックス',
      'リモートワーク中心',
      'パートタイム・業務委託',
    ],
  },
  balanceOrientation: {
    question: '両立に対する考え方',
    options: [
      '競技のためなら仕事の制約は受け入れる',
      '両立できる範囲で最大限の努力をしたい',
      'ワークライフバランスを重視しつつ競技も続けたい',
      '段階的に仕事にシフトしていきたい',
    ],
  },
  nonNegotiable: {
    question: '競技を続ける上で譲れない条件',
    options: [
      '練習時間の確保（毎日決まった時間）',
      '大会出場のための休暇取得',
      '遠征・合宿への参加',
      '体調管理のための柔軟な勤務体制',
      '競技に理解のある職場環境',
      '収入の安定（生活費・競技費用）',
    ],
  },
};
